export default "__VITE_ASSET__BJfsaWWa__"